
// This is an auto generated file - do not edit!
// Swagger path: /api/LogicStep

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    LogicStepDefinition, SystemEntity
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LogicstepApiService extends BaseApiService {
    
    get(entityType?: SystemEntity, options = {}): Observable<LogicStepDefinition[]> {
        let params = new HttpParams();
        if(entityType !== undefined) {
            params = params.append('entityType', entityType);
        }

        return this._get<LogicStepDefinition[]>(
            `/LogicStep`, {
                ...options,
                params,
            }
        );
    }
}
